var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"sidebar-component-container",class:{ mastery: _vm.isMastery }},[_c('div',{staticClass:"bar"},[_c('menu-list',{attrs:{"mastery":_vm.isMastery,"navigation-items":_vm.navigationItems,"on-tour":_vm.onTour}}),_vm._v(" "),_c('menu-footer',{attrs:{"on-tour":_vm.onTour}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }